import React, { useState, useEffect } from "react";
import HouseService from "../../services/houseService";
import HouseItem from "./HouseItem";

const HouseList = () => {
  const [houses, setHouses] = useState(null); // Start with `null`
  const houseService = HouseService();
  const [loading, setLoading] = useState(true); // Add loading state

  const saleHouses_offline = [
    {
      images: [{ imageName: "img/h1.webp" }, { imageName: "img/h2.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Condina",
      price: 150000000,
      rooms: 5,
      parking: 1,
      baths: 3,
      squaremts: 90,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h2.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Cerritos",
      price: 270000000,
      rooms: 4,
      parking: 2,
      baths: 3,
      squaremts: 140,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
    {
      images: [{ imageName: "img/h3.webp" }],
      houseStatus: "En Venta",
      title: "Casa en Pinares",
      price: 350000000,
      rooms: 7,
      parking: 3,
      baths: 5,
      squaremts: 200,
      houseDescription:
        "Ven y conoce esta hermosa casa para compartir en familia.",
    },
  ];

  useEffect(() => {
    const fetchHouses = async () => {
      try {
        const response = await houseService.getHouses();
        if (Array.isArray(response)) {
          // console.log("First item in response:", response[0]);
        } else {
          //console.log("Response is not an array:", response);
        }
        setHouses(response);
      } catch (error) {
        console.error("Error fetching houses:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchHouses();
  }, []); // Empty dependency array to run once on mount

  if (loading) {
    return <div>Loading...</div>; // Render a loading indicator
  }

  const dataToDisplay =
    Array.isArray(houses) && houses.length > 0 ? houses : saleHouses_offline;

  const housesType =
    Array.isArray(houses) && houses.length > 0 ? "onlione" : "offline";
  //console.log("DATA TO DISPLAY", dataToDisplay);
  return (
    <div>
      <div className="recent-house-cards-container">
        {dataToDisplay.map((house, index) => (
          <HouseItem key={index} house={house} type={housesType} />
        ))}
      </div>
    </div>
  );
};

export default HouseList;
